import VehicleStatus from '../components/views/VehicleStatus/VehicleStatus.vue'

const routes = [{
    path: 'vehicle_status',
    component: VehicleStatus,
    name: 'VehicleStatus',
    meta: {
        title: 'Vehicles Status'
    }
}]

export default routes


// WEBPACK FOOTER //
// ./src/routes/VehicleStatus.route.js